<svg
  viewbox="0 0 128 128"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M93.1648 128H20.2534C9.088 128 0 118.912 0 107.747V20.2534C0 9.088
    9.088 0 20.2534 0H93.1648C112.372 0 128 15.6262 128 34.8352C128
    47.0259 121.706 57.7741 112.197 64C121.706 70.2259 128 80.9741 128
    93.1648C128 112.374 112.372 128 93.1648 128ZM20.2534 11.3421C17.8908
    11.3448 15.6258 12.2845 13.9552 13.9552C12.2845 15.6258 11.3448
    17.8908 11.3421 20.2534V107.747C11.3448 110.109 12.2845 112.374
    13.9552 114.045C15.6258 115.715 17.8908 116.655 20.2534
    116.658H93.1648C106.118 116.658 116.658 106.118 116.658
    93.1648C116.658 81.9648 108.782 72.5709 98.2771 70.231C95.3318 86.4768
    81.0816 98.8352 64 98.8352C62.4961 98.8352 61.0538 98.2378 59.9904
    97.1744C58.927 96.111 58.3296 94.6687 58.3296 93.1648C58.3296 80.9741
    64.6221 70.2259 74.1325 64C64.6221 57.7741 58.3296 47.0259 58.3296
    34.8352C58.3296 33.3313 58.927 31.889 59.9904 30.8256C61.0538 29.7622
    62.4961 29.1648 64 29.1648C81.0816 29.1648 95.3318 41.5232 98.2771
    57.769C108.782 55.4291 116.658 46.0352 116.658 34.8352C116.658 21.8816
    106.118 11.3421 93.1648 11.3421H20.2534ZM86.5446 70.6202C82.7734
    71.737 79.3411 73.7788 76.56 76.56C73.7788 79.3411 71.737 82.7734
    70.6202 86.5446C74.3913 85.4276 77.8235 83.3857 80.6046
    80.6046C83.3857 77.8235 85.4276 74.3913 86.5446 70.6202ZM70.6202
    41.4554C71.737 45.2266 73.7788 48.6589 76.56 51.4401C79.3411 54.2212
    82.7734 56.263 86.5446 57.3798C85.4276 53.6087 83.3857 50.1765 80.6046
    47.3954C77.8235 44.6143 74.3913 42.5724 70.6202 41.4554Z" />
</svg>